import { ProgressIndicator, Shimmer, ShimmerElementType } from "@fluentui/react";


const shimmerWithElementFirstRow = [
    { type: ShimmerElementType.gap, width: '2%' },
    { type: ShimmerElementType.line },
];

const shimmerWithElementFirstRowCircle = [
    { type: ShimmerElementType.circle, width: '10%'},
];

interface ISimmerProgress {
    /**Desabilita (oculta) Linea de Progreso */
    disabled?: boolean
    /**Texto de envio*/
    prefix?: string
}

/**LInea de progreso*/
export function LineProgress({ disabled = true, prefix = 'Espere Un Momento' }: ISimmerProgress) {
    return (
        <div className="ms-Grid-col ms-sm12 ms-lg12" hidden={disabled}>
            <ProgressIndicator description={`${prefix}`} barHeight={3} />
        </div>
    );
}

/**Barra Simmer*/
export function SimmerProgress({ disabled = true, prefix = '' }: ISimmerProgress) {
    return (
        <div className="ms-Grid-col ms-sm12 ms-lg12" hidden={disabled} style={{minWidth:300}}>
            <Shimmer width="100%" shimmerElements={shimmerWithElementFirstRow} />
            <p style={{paddingLeft:10}} className="ms-fontSize-10">{prefix}</p>
        </div>
    );
}

export function SimmerProgressList({ disabled = true, prefix = '' }: ISimmerProgress) {
    return (
        <div className="ms-Grid-col ms-sm12 ms-lg12" hidden={disabled} style={{minWidth:100}}>
            <br />
            <Shimmer width="100%" shimmerElements={shimmerWithElementFirstRow} /><br />
            <Shimmer width="100%" shimmerElements={shimmerWithElementFirstRow} /><br />
            <Shimmer width="100%" shimmerElements={shimmerWithElementFirstRow} /><br />
            <p style={{paddingLeft:10}} className="ms-fontSize-10">{prefix}</p>
        </div>
    );
}

/**Barra Simmer*/
export function SimmerProgressCircle({ disabled = true, prefix = '' }: ISimmerProgress) {
    return (
        <div className="ms-Grid-col ms-sm12 ms-lg12" hidden={disabled} style={{minWidth:300}}>
            <Shimmer width="100%" shimmerElements={shimmerWithElementFirstRowCircle} />
            <p className="ms-fontSize-10">{prefix}</p>
        </div>
    );
}
